<template>
  <el-dialog title="提示" :visible.sync="dialogVisible" width="800px" @close="handleClose">
    <template v-if="type == 'single'">
      <div style="margin-top: 20px;">当前使用类目：<span style="color:#2695FA;font-weight:bold;">{{dataList && dataList.length ? dataList[0].catNames:''}} </span> 与抖音平台推荐使用类目不符，
        存在<span style="color:red;font-weight:bold;">类目错挂风险</span>，建议前往商品修改</div>
    </template>
    <template v-if="type == 'multi'">
      <div>
         <div>下列商品使用类目与抖音平台推荐使用类目不符，
            存在<span style="color:red;font-weight:bold;">类目错挂风险</span>，建议前往抖音资料修改
         </div>
         <el-table
            :data="dataList"
            stripe
            style="width: 100%">
            <el-table-column
            prop="mainImage"
            label="图片"
            width="180">
            <template slot-scope="scope">
              <div>
                <el-image :preview-src-list="[scope.row.mainImage]" style="width: 80px; height: 80px; margin-right: 5px;border-radius:4px;" :src="scope.row.mainImage" />
              </div>
            </template>
            </el-table-column>
            <el-table-column
            prop="outId"
            label="商品详情"
            width="180">
                <template slot-scope="scope">
                    <div>{{scope.row.title}}</div>
                    <div>款式编码：{{scope.row.outId}}</div>
                    <div>类目：{{(scope.row.catNames).replace(/,/g,'>')}}</div>
                </template>
            </el-table-column>
            <el-table-column
                fixed="right"
                label="操作"
                width="150">
                <template slot-scope="scope">
                    <el-button @click="handleModify(scope.row)" type="text" size="small">前往更新</el-button>
                </template>
            </el-table-column>
        </el-table>

      </div>
    </template>
    <EditDialog ref="editDialog"></EditDialog>

    <div slot="footer" class="dialog-footer flex pdlr20" style="justify-content: center;">
      <div v-if="type == 'single'">
        <el-button  type="primary" @click="handleModify(dataList && dataList.length ? dataList[0]:{})">前去调整</el-button>
        <el-button @click="onOk">继续铺货</el-button>
      </div>
      <div v-if="type == 'multi'">
        <el-button type="primary" @click="onOk">继续铺货</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import EditDialog from "@/components/prod/center/dialogs/EditDialog.vue";

export default {
  data() {
    return {
      cb: null,
      type: '', //single multi
      dialogVisible: false,
      dataList: [],
      rowsData: [],
    };
  },
  components: {
    EditDialog,
  },
  methods: {
    handleClose() {
    },
    method_open({ type,list,rowsData, cb }) {
      this.cb = cb;
      this.type = type;
      this.dataList = list
      this.rowsData = rowsData
      this.dialogVisible = true;
    },

    handleModify(data) {
      this.dialogVisible = false;
      const needEditItem = this.rowsData.find(item=>item.baseItemId == data.baseItemId)
      this.$refs.editDialog.method_open(_.assign({}, needEditItem, { activeName: 'fxg' }))
      this.cb(false)
    },
    onOk(){
        this.dialogVisible = false
        this.cb(true)
    },
  },
};
</script>

<style lang="scss" scoped>
.btns {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  // justify-content: space-between;
}
.center-title {
  line-height: 24px;
  font-size: 14px;
  color: #fff;
}
.tips {
  font-size: 12px;
  display: inline-block;
  margin-left: 20px;
  color: #fff;
  opacity: 0.6;
}
</style>
